import { useState, useEffect, useCallback } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import EditIcon from "@mui/icons-material/Edit";
import { Box, DialogContent } from "@mui/material";
import { useApi } from "../../../utils/Api";
import Translate from "../../../utils/Translate";
import DotMenu from "../../DotMenu";
import Preloader from "../../Preloader";
import HelpCategoryEditDialog from "./HelpCategoryEditDialog";

const MAIN_URL = import.meta.env.VITE_MAIN_URL;

function accessKeyLabel(accessKey) {
  if (accessKey === "ICA") {
    return Translate.get("ePortCloudLicenseLineType_7");
  }
  if (accessKey === "PERMITS") {
    return Translate.get("ePortCloudLicenseLineType_8");
  }
  return accessKey;
}

export default function HelpCategoriesDialog({ onSaved }) {
  const api = useApi();

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    const response = await api.fetch(`${MAIN_URL}help/admin/categories`, false, "GET");
    if (response && response.isSuccessful && Array.isArray(response.categories)) {
      setCategories(response.categories);
    }
    setLoading(false);
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  const handleSaved = useCallback(() => {
    reload();
    if (onSaved) {
      onSaved();
    }
  }, [reload, onSaved]);

  const columns = [
    { field: "description", headerName: Translate.get("HelpArticleDescriptionInternal"), flex: 1 },
    { field: "reference", headerName: Translate.get("HelpCategoryReference"), flex: 1 },
    {
      field: "accessKey",
      headerName: Translate.get("EPortProfile"),
      flex: 1,
      valueGetter: (value) => accessKeyLabel(value),
    },
    {
      field: "dotMenu",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "right",
      renderCell: (params) => (
        <DotMenu
          horizontal
          content={[
            {
              icon: <EditIcon />,
              text: Translate.get("Alter"),
              dialogHeader: Translate.get("Alter"),
              component: <HelpCategoryEditDialog category={params.row} onSaved={handleSaved} />,
            },
          ]}
        />
      ),
    },
  ];

  return (
    <DialogContent>
      {loading ? (
        <Preloader />
      ) : (
        <DataGrid
          rows={categories}
          columns={columns}
          getRowId={(row) => row.helpCategoryId}
          disableRowSelectionOnClick
        />
      )}
    </DialogContent>
  );
}
